import React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../molecules/UnderlinedHeader/UnderlinedHeader";

const About = () => (
  <StyledAbout>
    <Container>
      <UnderlinedHeader text={"O nas"} bolder />
      <p>
        Pedders Suspension to wiodący australijski producent elementów
        zawieszenia i układu hamulcowego. Swoją markę buduje już od 70 lat,
        systematycznie umacniając wysoką pozycję w przemyśle motoryzacyjnym na
        Antypodach.
      </p>
      <p>
        Firma rozpoczęła działalność w roku 1950, kiedy to Roy Pedder założył
        przedsiębiorstwo Pedders Die-Cast Welding Service (Usługi Spawania
        Odlewów), którego rolą miało być zapełnienie rynkowej niszy w zakresie
        serwisu amortyzatorów. Z końcem lat 50-tych firma zatrudniała 13 osób,
        które naprawiały ponad 3000 amortyzatorów miesięcznie.
      </p>
      <p>
        W roku 1972 stery zarządzania przejął najstarszy syn Roya, Ron, który na
        bazie zdobytych doświadczeń w modyfikowaniu i udoskonalaniu produktów
        rozpoczął tworzenie autorskich modeli amortyzatorów. By zapewnić im
        dystrybucję, równolegle zaczął rozwijać sieć sklepów firmowych,
        pełniących zarazem funkcję punktów montażowych i serwisowych.
      </p>
      <p>
        Biznes prowadzony jest obecnie przez najstarszego syna Rona – Marka
        Peddersa, który objął stanowisko dyrektora zarządzającego w roku 2006.
        Ta duża, międzynarodowa firma motoryzacyjna przeszła długą drogę od
        podmiejskiego zakładu spawalniczego w Melbourne. Cały ten wzrost i
        rozwój zawdzięcza determinacji, poświęceniu i patrzeniu w przyszłość
        przez nasz najważniejszy czynnik - naszych ludzi. Obecnie Pedders ma
        ponad 120 sklepów w całej Australii obsługiwanych przez 5 centrów
        dystrybucji.
      </p>
      <p>
        Od czasu rozszerzenia sprzedaży na rynki zagraniczne swoje magazyny ma
        między innymi w Polsce, Wielkiej Brytanii, Zjednoczonych Emiratach
        Arabskich, Tajlandii, Indonezji, Chinach, Malezji, Płd. Afryce i USA.
      </p>
      <p>
        Dla każdego nowego podwozia Pedders opracowuje zintegrowane rozwiązanie
        zawieszenia. Niezależnie od tego, czy chodzi o części zamienne tzw. OEM,
        części do samochodów osobowych, czy też wzmocnione zawieszenia terenowe,
        jesteśmy jednym z nielicznych producentów oferujących kompleksowe
        rozwiązanie.
      </p>
      <p>
        Zaczynaliśmy jako firma zajmująca się amortyzatorami, dziś jesteśmy
        znakomici w swojej dziedzinie, ponieważ oferujemy „system”, który
        projektujemy, produkujemy, dystrybuujemy, a w Australii również
        montujemy pod marką Pedders. Nasza gama produktów obejmuje amortyzatory,
        sprężyny (również resory i amortyzatory skrętu), tuleje (poliuretan i
        guma), części podwozia, osprzęt (sworznie, odbojniki, elementy
        stabilizatora, mocowania itp.), wahacze, przekładnie i pompy wspomagania
        kierownicy, przeguby i wały CV, a nawet części hamulców, w tym klocki,
        tarcze i bębny. Wszystko to tworzy Pedders - SYSTEM.
      </p>
      <p>
        Swoją działalność w Europie Pedders rozpoczął od sukcesywnego
        wprowadzania na rynek zamienników amortyzatorów dedykowanych autom
        terenowym, między innymi Subaru Forester, Nissan X-Trail i Patrol,
        Toyota Land Cruiser, Mitsubishi Pajero, Isuzu D-Max, Volkswagen Amarok
        oraz Ford Ranger. Następnie przeszliśmy do większej liczby marek i
        modeli. Rezultaty pracy z aplikacjami dla których produkowaliśmy części
        były niesamowite. Udoskonalamy wszystko, aby mieć pewność, że wyniki
        testów są na wyższym poziomie wydajności, który oczekują i osiągają nasi
        klienci. Dokumentujemy każdy krok naszego rozwoju na forach entuzjastów,
        aby mogli skorzystać z doświadczeń naszej ciężkiej pracy.
      </p>
      <p>
        Jakość jazdy jest subiektywna. Nasze samochody testowe służą do
        codziennej jazdy. Ponieważ wykonujemy nasze prace badawczo-rozwojowe w
        Australii i Europie, naszym celem jest osiągnięcie efektu Peddersa”,
        czyli: idealnej równowagi między przyjemnością, a wydajnością
        prowadzenia.
      </p>
      <p>
        Nasz szybki rozwój na rynku europejskim jest poparty naszym
        zaangażowaniem na rzecz klienta. Chętnie przyjmujemy opinie, ponieważ
        dzięki nim możemy ciągle być lepsi. Nasze rozwiązania produktowe są
        odpowiedzią na Twoje potrzeby i oczekiwania. Kiedy myślimy o Pedders
        Polska, myślimy o Tobie i Twoich potrzebach. Wykonujemy naszą pracę dla
        naszych klientów aby osiągnąć jeszcze lepszy efekt. Wszystko, co robimy,
        jest napędzane przez Ciebie!
      </p>
      <p>
        Witryna Pedders.pl jest administrowana przez oficjalnego dystrybutora
        Pedders - OZPARTS PL sp. z o.o. we współpracy z Pedders Shock
        Absorber Service Pty Ltd.
      </p>
    </Container>
  </StyledAbout>
);

export default About;

const StyledAbout = styled.section`
  padding-top: 92px;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  color: #666666;
`;
